import { render, staticRenderFns } from "./Add-Broadband-Data-Plan.vue?vue&type=template&id=9822e7fe&scoped=true"
import script from "./Add-Broadband-Data-Plan.vue?vue&type=script&lang=js"
export * from "./Add-Broadband-Data-Plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9822e7fe",
  null
  
)

export default component.exports